import { Formik } from 'formik';
import { StepContainer, StepContent, StepForm, StepHeading, StepNavigator, StepNextButton } from '../../components';
import { OnboardingMachineContext, ProviderExperienceFilterNextData } from '../types';
import { CheckboxesFormRow } from '../../../components';
import { useCommunityExpertiseGeneralQuery, useEthnicitiesQuery, useFaithsQuery } from '@uplift/queries';

export type ProviderExperienceFilterProps = {
  onNext: (data: ProviderExperienceFilterNextData) => void;
  onBack: () => void;
  experienceFilters: OnboardingMachineContext['experienceFilters'];
};

export const ProviderExperienceFilter: React.VFC<ProviderExperienceFilterProps> = props => {
  const { data: communities = [] } = useCommunityExpertiseGeneralQuery();
  const { data: faiths = [] } = useFaithsQuery();
  const { data: ethnicities = [] } = useEthnicitiesQuery();

  return (
    <Formik
      initialValues={props.experienceFilters}
      onSubmit={props.onNext}
    >
      {formik => (
        <StepContainer>
          <StepContent>
            <StepHeading>Provider’s Experience With</StepHeading>
            <StepForm onSubmit={formik.handleSubmit}>
              <CheckboxesFormRow
                name="communityIds"
                title="Social Communities"
                options={communities}
                getLabel={opt => opt.name}
                getValue={opt => opt.id}
              />
              <CheckboxesFormRow
                name="faithIds"
                title="Faith Communities"
                options={faiths}
                getLabel={opt => opt.name}
                getValue={opt => opt.id}
              />
              <CheckboxesFormRow
                name="ethnicityIds"
                title="Ethnicity Communities"
                options={ethnicities}
                getLabel={opt => opt.name}
                getValue={opt => opt.id}
              />
            </StepForm>
          </StepContent>
          <StepNavigator onBack={props.onBack}>
            <StepNextButton />
          </StepNavigator>
        </StepContainer>
      )}
    </Formik>
  );
};
